module.exports = __webpack_public_path__ + "static/media/qr_code_scanner_disabled.6cc25c71.svg";